import { State } from 'models';
import { useSelector, TypedUseSelectorHook } from 'react-redux';

export const useStateSelector: TypedUseSelectorHook<State> = useSelector;
